// removed by extract-text-webpack-plugin
module.exports = {"multiUpload":"style__multiUpload__xOOTP","ant-upload":"style__ant-upload__4DoRq","avatarUploader":"style__avatarUploader__3RDlU","avatarUploaderTrigger":"style__avatarUploaderTrigger__3SlJu","avatar":"style__avatar__219X_","satUploader":"style__satUploader__laf7m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Widgets/MultiWidget/style.less
// module id = 1157
// module chunks = 0